import React from 'react';
import { Global, css } from '@emotion/core';
import cssReset from 'modern-css-reset';
import { useTheme } from 'emotion-theming';
import { ThemeProps } from '../../../types';
import { storageBucket, textReplacer } from '../../../utils';

const GlobalStyles = () => {
  const theme: ThemeProps = useTheme();
  const backgroundImageUrl = theme.images?.background
    ? textReplacer(theme.images?.background, {
        '{STORAGE_BUCKET}': storageBucket,
      })
    : '';

  return (
    <>
      <Global
        styles={css`
          ${cssReset}
          * {
            box-sizing: border-box;
            font-family: ${theme.fonts.families};
          }
          html {
            font-size: 16px;
            height: -webkit-fill-available;
          }
          body {
            background-color: ${theme.colors.background.backdrop};
            background-image: url(${backgroundImageUrl as string});
            background-repeat: no-repeat;
            background-size: cover;
            background-attachment: fixed;
            padding-bottom: 1px;
          }
          button,
          input {
            line-height: normal;
          }
          p {
            line-height: 1.25;
            margin: 0;
          }
        `}
      />
    </>
  );
};

export default GlobalStyles;
